import React from "react";

// @material-ui/icons
import FiberManualRecord from '@material-ui/icons/FiberManualRecord';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Radio from '@material-ui/core/Radio';
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Check from "@material-ui/icons/Check";

// core components
import GridContainer from "../../../components/Grid/GridContainer.jsx";
import GridItem from "../../../components/Grid/GridItem.jsx";
import CustomInput from "../../../components/CustomInput/CustomInput.jsx";

import customCheckboxRadioSwitch from "../../../assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";

const style = {
	checkBoxLabelError: {
		background: "#ff0000"
	},
	infoText: {
		fontWeight: "300",
		margin: "10px 0 30px",
		textAlign: "center"
	},
	inputAdornmentIcon: {
		color: "#555"
	},
	inputAdornment: {
		position: "relative"
	},
	...customCheckboxRadioSwitch
};

class Step4 extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			checked: "",
			selected: "",
			description: "",
			featuresCustom: "",
			featuresStandards: ""
		};
	}

	renderDescription(){
		this.setState({
			selected: this.state.checked.join(", "),
			description: [
				"Optionen: ",
				this.state.featuresCustom,
				"Normen: ",
				this.state.featuresStandards
			].join(' ')
		})
	}

	change(event, stateName){
		this.setState({ [stateName]: event.target.value }, () => {
			this.renderDescription();
		});
	}

	handleToggle(value) {
		const { checked } = this.state;
		const currentIndex = checked.indexOf(value);
		const newChecked = [...checked];

		if (currentIndex === -1) {
			newChecked.push(value);
		} else {
			newChecked.splice(currentIndex, 1);
		}

		this.setState({
			checked: newChecked
		},() => {
			this.renderDescription();
		});
	}

	sendState() {
		return this.state;
	}

	isValidated() {
		return true;
	}

	isError(){
		return this.state.selectedState === "error"
	}

	render() {
		const { classes } = this.props;
		return (
			<div>
			<GridContainer justify="center" alignItems="center" direction="row">
				<GridItem xs={12}>
					<h4 className={classes.infoText}>
						Welche zusätzlichen Features?
					</h4>
				</GridItem>
			</GridContainer>
			<GridContainer justify="center" alignItems="center" direction="row">
				<GridItem xs={3}>
				<div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
					<FormControlLabel
						control={
							<Checkbox
								onClick={event => {
									this.handleToggle("Automatische Bilderkennung");
								}}
								icon={<Check className={classes.uncheckedIcon} />}
								checkedIcon={<Check className={classes.checkedIcon} />}
								classes={{
									checked: classes.checked
								}}
							/>
						}
						classes={{label: classes.label}}
						label="Autom. Bilderkennung"
					/>
				</div>
				</GridItem>
				<GridItem xs={3}>
				<div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
					<FormControlLabel
						control={
							<Checkbox
								onClick={event => {
									this.handleToggle("MES-Anbindung");
								}}
								icon={<Check className={classes.uncheckedIcon} />}
								checkedIcon={<Check className={classes.checkedIcon} />}
								classes={{
									checked: classes.checked
								}}
							/>
						}
						classes={{label: classes.label}}
						label="MES-Anbindung"
					/>
				</div>
				</GridItem>
				<GridItem xs={3}>
				<div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
					<FormControlLabel
						control={
							<Checkbox
								onClick={event => {
									this.handleToggle("Inspektion /QM");
								}}
								icon={<Check className={classes.uncheckedIcon} />}
								checkedIcon={<Check className={classes.checkedIcon} />}
								classes={{
									checked: classes.checked
								}}
							/>
						}
						classes={{label: classes.label}}
						label="Inspektion /QM"
					/>
				</div>
				</GridItem>
				</GridContainer>
				<GridContainer justify="center" alignItems="center" direction="row">
				<GridItem xs={9}>
					<CustomInput
						labelText="Weitere gewünschte Optionen"
						id="custom-features"
						formControlProps={{
							fullWidth: true
						}}
						inputProps={{
							onChange: event => this.change(event, "featuresCustom")
						}}
					/>
				</GridItem>
				<GridItem xs={9}>
					<CustomInput
						labelText="Zu berücksichtigende Normen z.B. CE, UL, SEMI"
						id="required-standards"
						formControlProps={{
							fullWidth: true
						}}
						inputProps={{
							onChange: event => this.change(event, "featuresStandards")
						}}
					/>
				</GridItem>
			</GridContainer>
			</div>
		);
	}
}

export default withStyles(style)(Step4);



// WEBPACK FOOTER //
// ./src/views/Configurator/ConfiguratorSteps/Step4.jsx